import client from "@irati/utils/services/apollo";
import { reportingActiveUsersSummaryQuery, reportingPerkRedemptionsSummaryQuery, reportingPerksGOTransactionsSummaryQuery, reportingPerkRedemptionsQuery, reportingMostPopularPerksQuery, reportingPlatformActivityQuery } from "./query";
var ReportingService = /** @class */ (function () {
    function ReportingService() {
        this.getActiveUsersSummary = function (variables) {
            return client
                .query({ query: reportingActiveUsersSummaryQuery, variables: variables, fetchPolicy: "network-only" })
                .then(function (_a) {
                var data = _a.data;
                return data.reportingActiveUsersSummary;
            });
        };
        this.getPerkRedemptionsSummary = function (variables) {
            return client
                .query({ query: reportingPerkRedemptionsSummaryQuery, variables: variables, fetchPolicy: "network-only" })
                .then(function (_a) {
                var data = _a.data;
                return data.reportingPerkRedemptionsSummary;
            });
        };
        this.getPerksGOTransactionsSummary = function (variables) {
            return client
                .query({ query: reportingPerksGOTransactionsSummaryQuery, variables: variables, fetchPolicy: "network-only" })
                .then(function (_a) {
                var data = _a.data;
                return data.reportingPerksGOTransactionsSummary;
            });
        };
        this.getPerkRedemptions = function (variables) {
            return client
                .query({ query: reportingPerkRedemptionsQuery, variables: variables, fetchPolicy: "network-only" })
                .then(function (_a) {
                var data = _a.data;
                return data.reportingPerkRedemptions;
            });
        };
        this.getMostPopularPerks = function (variables) {
            return client
                .query({ query: reportingMostPopularPerksQuery, variables: variables, fetchPolicy: "network-only" })
                .then(function (_a) {
                var data = _a.data;
                return data.reportingMostPopularPerks;
            });
        };
        this.getPlatformActivity = function (variables) {
            return client
                .query({ query: reportingPlatformActivityQuery, variables: variables, fetchPolicy: "network-only" })
                .then(function (_a) {
                var data = _a.data;
                return data.reportingPlatformActivity;
            });
        };
    }
    return ReportingService;
}());
export default new ReportingService();
